// extracted by mini-css-extract-plugin
export var alertIcon = "_rb-0";